import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { SimpleGrid, Container, Divider, Text, Flex } from "@chakra-ui/react"

import BackToTop from "./BackToTop"
import Telephone from "./Telephone"
import OpenTimes from "./OpenTimes"
import CopyRight from "./CopyRight"
import Address from "./Address"
import Social from "./Social"

export function Footer() {
  const { dataJson } = useStaticQuery(graphql`
    query {
      dataJson {
        contact {
          registration
          social {
            facebook
            youtube
            linkedIn
          }
          open {
            time
            day
          }
          contact {
            tel
            email
          }
          address {
            building
            postcode
            county
            city
          }
        }
      }
    }
  `)

  const { registration, contact, open, address, social } = dataJson.contact

  return (
    <Flex
      bgGradient="linear(to-r, base.d200 2.5%, base.d400 , base.d200 97.5%)"
      mt={{ base: 10, lg: 0 }}
      flexDirection="column"
      position="relative"
      width="full"
      as="footer"
    >
      <BackToTop />

      <Container pt={20}>
        <Social data={social} />
        <Text size="sm" textAlign="center">
          {registration}
        </Text>

        <Divider mt={16} pb={16} />

        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={{ base: 20, lg: 16 }}>
          <Telephone data={contact} />
          <OpenTimes data={open} />
          <Address data={address} />
        </SimpleGrid>
      </Container>
      <CopyRight />
    </Flex>
  )
}
